import { useState } from 'react';

export default function NettoyageCTA() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', service: '', surface: '', message: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new URLSearchParams();
    Object.entries(formData).forEach(([key, value]) => data.append(key, value));
    try {
      await fetch('https://formsubmit.co/ajax/info@hbservices.ch', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
    } finally {
      setSubmitted(true);
    }
  };

  return (
    <section id="contact-nettoyage" className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <h2 className="text-4xl font-bold text-white mb-6">Demandez votre devis gratuit</h2>
            <p className="text-gray-400 text-lg leading-relaxed mb-10">
              Réponse sous 24h. Nos experts se déplacent gratuitement pour évaluer vos besoins et vous proposer la solution la plus adaptée.
            </p>
            <div className="space-y-6">
              {[
                { icon: 'ri-phone-line', title: 'Téléphone', value: '+41 76 480 31 88 | +41 76 565 42 03' },
                { icon: 'ri-mail-line', title: 'Email', value: 'info@hbservices.ch' },
                { icon: 'ri-map-pin-line', title: 'Adresse', value: 'Route du Mandement 17, 1217 Meyrin' },
                { icon: 'ri-time-line', title: 'Disponibilité', value: 'Lun-Sam: 7h00 - 20h00 | Urgences 7j/7' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-500/20 rounded-lg shrink-0">
                    <i className={`${item.icon} text-lg text-orange-400`}></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 font-medium">{item.title}</p>
                    <p className="text-white font-semibold">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700">
            {submitted ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-500/20 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-orange-400"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Demande envoyée !</h3>
                <p className="text-gray-400">Nous vous recontactons sous 24h pour votre devis gratuit.</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                <h3 className="text-xl font-bold text-white mb-6">Votre demande de devis</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-1">Nom complet *</label>
                    <input type="text" name="name" required onChange={handleChange} placeholder="Jean Dupont"
                      className="w-full rounded-lg bg-gray-700 border border-gray-600 px-4 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-1">Téléphone</label>
                    <input type="tel" name="phone" onChange={handleChange} placeholder="+41 79 000 00 00"
                      className="w-full rounded-lg bg-gray-700 border border-gray-600 px-4 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-1">Email *</label>
                  <input type="email" name="email" required onChange={handleChange} placeholder="votre@email.ch"
                    className="w-full rounded-lg bg-gray-700 border border-gray-600 px-4 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-1">Type de service *</label>
                  <select name="service" required onChange={handleChange}
                    className="w-full rounded-lg bg-gray-700 border border-gray-600 px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-orange-500 cursor-pointer">
                    <option value="">Sélectionnez un service</option>
                    <option value="Nettoyage résidentiel">Nettoyage résidentiel</option>
                    <option value="Nettoyage bureaux/commerces">Nettoyage bureaux / commerces</option>
                    <option value="Conciergerie immeuble">Conciergerie d&apos;immeuble</option>
                    <option value="Nettoyage spécialisé">Nettoyage spécialisé</option>
                    <option value="Fin de bail">Nettoyage fin de bail</option>
                    <option value="Autre">Autre</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-1">Surface approximative</label>
                  <select name="surface" onChange={handleChange}
                    className="w-full rounded-lg bg-gray-700 border border-gray-600 px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-orange-500 cursor-pointer">
                    <option value="">Sélectionnez une surface</option>
                    <option value="Moins de 50 m²">Moins de 50 m²</option>
                    <option value="50 - 100 m²">50 – 100 m²</option>
                    <option value="100 - 200 m²">100 – 200 m²</option>
                    <option value="200 - 500 m²">200 – 500 m²</option>
                    <option value="Plus de 500 m²">Plus de 500 m²</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-1">Message</label>
                  <textarea name="message" rows={3} maxLength={500} onChange={handleChange}
                    placeholder="Décrivez vos besoins, fréquence souhaitée, contraintes particulières..."
                    className="w-full rounded-lg bg-gray-700 border border-gray-600 px-4 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"></textarea>
                </div>
                <button type="submit" className="w-full rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold text-white hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer">
                  Envoyer ma demande de devis
                </button>
                <p className="text-xs text-gray-500 text-center">Réponse garantie sous 24h. Devis 100% gratuit et sans engagement.</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
